import { render } from "./TopUp.vue?vue&type=template&id=35875708&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"

import "./TopUp.vue?vue&type=style&index=0&id=35875708&scoped=true&lang=scss"
import "./TopUp.vue?vue&type=style&index=1&id=35875708&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35875708"]])

export default __exports__